<div>
  <h1>GL-Codes</h1>

  @if(mode==='EDIT') {
    <button (click)="switchToCreateMode()" >Create mode</button>
  }
  
  <div>
    @if(glCodeForm) {
      <form [formGroup]="glCodeForm">

        <div>{{ currentId }}</div>

        <mat-form-field>
          <mat-label>GL code</mat-label>
          <input type="text" matInput formControlName="glCode" placeholder="123-123-123">
        </mat-form-field>
  
        <mat-form-field>
          <mat-label>Label</mat-label>
          <input type="text" matInput formControlName="label" placeholder="abc">
        </mat-form-field>

        <button (click)="createOrUpdateGlCode()" [disabled]="glCodeForm.invalid && !glCodeForm.touched" mat-raised-button>{{mode==='CREATE' ? 'Create GL Code' : 'Edit GL Code'}}</button>
      </form>
    }

  </div>

  <div>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
      </ng-container>
    
      <!-- Name Column -->
      <ng-container matColumnDef="glCode">
        <th mat-header-cell *matHeaderCellDef> GL code </th>
        <td mat-cell *matCellDef="let element"> {{element.glCode}} </td>
      </ng-container>
    
      <!-- Weight Column -->
      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef> Label </th>
        <td mat-cell *matCellDef="let element"> {{element.label}} </td>
      </ng-container>
    
      <!-- Symbol Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element">
          <button (click)="editRow(element)" mat-raised-button>Edit</button>
          <button mat-raised-button [disabled]="true">Delete</button>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <form></form>
</div>